import React from 'react';
import ContentLoader from 'react-content-loader';
import { Accordion, AccordionSummary } from './styles';

const Row = () => {
  const widthSet = 360;
  const minHeight = 15;

  return (
    <Accordion>
      <AccordionSummary aria-controls="panel-content">
        <ContentLoader height={minHeight} width={widthSet} speed={1}>
          <rect x="5" y="2" rx="4" width="45%" height="10" />
        </ContentLoader>
      </AccordionSummary>
    </Accordion>
  );
};

export default Row;
